"use strict";

var _header = require("header");

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var head = {
    init: function init() {
        var domain = 'events.gm99.com';
        _header2["default"].render(domain, ".cm-top-bg");
    }
};
module.exports = head;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/util/header.js
// module id = 351
// module chunks = 7